import { useState, useEffect } from "react";
import { autoUpdate } from "./auth-service-tools368.js";
import { useDidUpdate } from "./auth-service-tools369.js";

function useFloatingAutoUpdate(_ref) {
  let {
    opened,
    floating,
    position,
    positionDependencies
  } = _ref;
  const [delayedUpdate, setDelayedUpdate] = useState(0);
  useEffect(() => {
    if (floating.refs.reference.current && floating.refs.floating.current && opened) {
      return autoUpdate(floating.refs.reference.current, floating.refs.floating.current, floating.update);
    }

    return void 0;
  }, [floating.refs.reference.current, floating.refs.floating.current, opened, delayedUpdate, position]);
  useDidUpdate(() => {
    floating.update();
  }, positionDependencies);
  useDidUpdate(() => {
    setDelayedUpdate(c => c + 1);
  }, [opened]);
}

export { useFloatingAutoUpdate };